export default "__VITE_ASSET__BOoNTEqM__"